import { render, staticRenderFns } from "./EditUserProfileDialog.vue?vue&type=template&id=7bbc0116&scoped=true"
import script from "./EditUserProfileDialog.vue?vue&type=script&lang=ts"
export * from "./EditUserProfileDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditUserProfileDialog.vue?vue&type=style&index=0&id=7bbc0116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc0116",
  null
  
)

export default component.exports